import { useMediaQuery } from "@mui/material"
import WebView from "./MissionWebView"
import MobileView from "./MissionMobileView"
export default function Mission(){
    const isSmallScreen = useMediaQuery('(max-width:760px)')
    return (
        <> 
        {
            isSmallScreen ?
            <MobileView/> 
            :
            <WebView/>
        }
          
        </>
    )
}